import axios from 'axios';
import ModalLoader from './components/ModalLoader';
import ModalFullPicture from './components/ModalFullPicture';

const WeACT = {
    install (Vue) {
        //We ACT Components
        this.EventBus = new Vue();
        Vue.component('ModalLoader', ModalLoader);
        Vue.component('ModalFullPicture', ModalFullPicture);

        //We ACT Config
        const WeConfig = {
            TimeLoader: 300
        };

        //We ACT Helper
        const WeHelper = {
            getBlobAPI(api, path, headers) {
                return new Promise((resolve, reject) => {
                    axios
                        .get(api + path, {
                            ...headers,
                            responseType: 'blob'
                        })
                        .then((response) => {
                            resolve(response);
                        })
                        .catch((error) => {
                            reject(error);
                        });
                });
            },
            postAPI(api, path, data, header) {
                return new Promise((resolve) => {
                    axios
                        .post(api + path, data, header)
                        .then((response) => { 
                            resolve(response);
                        });
                });
            },
            isNullOrEmpty(object) {
                if (object == '' || object == null || typeof object == 'undefined') {
                    return true;
                }
            
                return false;
            },
            getQueryString(key) {
                String.prototype.getValueByKey = function (k) {
                    var p = new RegExp('\\b' + k + '\\b', 'gi');
                    return this.search(p) != -1 ? decodeURIComponent(this.substr(this.search(p) + k.length + 1).substr(0, this.substr(this.search(p) + k.length + 1).search(/(&|;|$)/))) : "";
                };
            
                return window.location.href.getValueByKey(key);
            },
            buildQueryString(params) {
                return Object.keys(params).map(function(key) {
                    return key + '=' + params[key]
                }).join('&');
            },
            getCommaNumber(value) {
                if (value) {
                    var parts = value.toString().split(".");
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                    return parts.join(".");
                }

                return value;
            },
            getLeadingZeroNumber(value, size) {
                var number = value + '';

                while (number.length < size) {
                    number = '0' + number;
                }
                
                return number;
            },
            validateEmail(email) {
                const checkEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
                
                if (email && !checkEmail.test(email)) {
                    return false;
                }
                
                return true;
            },
            modalLoad() {
                const instance = new (Vue.extend(ModalLoader))({
                    el: document.createElement('div')
                });
                
                document.body.appendChild(instance.$el);

                return instance;
            },
            modalFullPicture(picture, name) {
                WeACT.EventBus.$emit('showFullPicture', { picture: picture, name: name });
            },
            modalScrollable(isDisplay) {
                const body = document.body;
                var scrollWidth = window.innerWidth - body.clientWidth;

                if (isDisplay) {
                    body.classList.add('modal-open');
                    body.style.paddingRight = scrollWidth + 'px';
                }
                else {
                    body.classList.remove('modal-open');
                    body.style.paddingRight = null;
                }
            },
            upperFirstChar(text) { 
                return text.charAt(0).toUpperCase() + text.slice(1); 
            }
        };

        Vue.prototype.$WeConfig = WeConfig;
        Vue.prototype.$WeHelper = WeHelper;
    }
}

export default WeACT